// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

type CheckedSessionStorage = {
  checked_right_strikers: string,
};

type CheckedRightStrikers = {
  select_right_type_id: string,
  select_stock_type_id: string,
  right_strikers_attributes: any,
};

export default class SelectSharesView extends JQueryView {
  checkedSessionStorage: CheckedSessionStorage;

  constructor() {
    super('.simple_form');

    // $FlowFixMe
    this.checkedSessionStorage = (sessionStorage: CheckedSessionStorage);
  }

  @on({
    event: 'click',
    selector: 'input[type="submit"][value="つぎへ"]',
  })
  onNextButtonClick() {
    if (this.checkedSessionStorage.checked_right_strikers) {
      const checkedRightStrikers: CheckedRightStrikers = JSON.parse(
        this.checkedSessionStorage.checked_right_strikers,
      );

      const currentRightTypeId = $(
        '#company_right_strike_select_form_select_right_type_key',
      )
        .val()
        .replace(/^right_type_/, '');
      const currentStockTypeId = $(
        '#company_right_strike_select_form_select_stock_type_key',
      )
        .val()
        .replace(/^stock_type_/, '');
      const sessionRightTypeId = checkedRightStrikers.select_right_type_id;
      const sessionStockTypeId = checkedRightStrikers.select_stock_type_id;

      // セッションストレージのメンバー選択入力内容と現在の画面の入力内容が違う場合はセッションをクリアする
      if (
        !(
          currentRightTypeId == sessionRightTypeId &&
          currentStockTypeId == sessionStockTypeId
        )
      ) {
        sessionStorage.removeItem('checked_right_strikers');
      }
    }
  }
}
